import { Suspense, useLayoutEffect } from 'react';

import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';

import AppRoute from '@/components/layouts/AppRoute';
import OtherRoutesLayout from '@/components/layouts/OtherRoutesLayout';
import { ProtectedRoute } from '@/components/layouts/ProtectedRoute';
import { PublicRoute } from '@/components/layouts/PublicRoute';
import { OfflineHandler } from '@/components/template/OfflineHandler';
import PageLoader from '@/components/template/PageLoader';
import { otherRoutes } from '@/configs/routes/other-routes';
import protectedRoutes from '@/configs/routes/protected-routes';
import publicRoutes from '@/configs/routes/public-routes';
import { PATHS } from '@/constants/page-paths';
import { useSettingsStore } from '@/store';

const AllRoutes = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        {protectedRoutes?.map((route) => (
          <Route
            key={route.routeKey}
            path={route.path}
            Component={() => <AppRoute {...route} />}
          />
        ))}
      </Route>
      <Route element={<PublicRoute />}>
        {publicRoutes?.map((route) => (
          <Route
            key={route.routeKey}
            path={route.path}
            Component={() => <AppRoute {...route} />}
          />
        ))}
      </Route>
      <Route element={<OtherRoutesLayout />}>
        {otherRoutes?.map((route) => (
          <Route
            key={route.routeKey}
            path={route.path}
            Component={() => <AppRoute {...route} />}
          />
        ))}
      </Route>
      <Route path="*" element={<Navigate to={PATHS.HOME} />} />
    </Routes>
  );
};

const Pages = () => {
  const { themeMode } = useSettingsStore();

  const Wrapper = ({ children }) => {
    const location = useLocation();

    useLayoutEffect(() => {
      if (location.hash) {
        const id = location.hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'instant' });
        }
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }
    }, [location]);

    return children;
  };

  return (
    <Wrapper>
      <OfflineHandler />
      <Toaster
        theme={themeMode === 'light' ? 'light' : 'dark'}
        position="bottom-center"
      />
      <Suspense fallback={<PageLoader />}>
        <AllRoutes />
      </Suspense>
    </Wrapper>
  );
};

export default Pages;
